import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class Globals {
	public configuracion;

	constructor(private router: Router) {
		
		this.configuracion = {
			//rootApiRestFull:'http://localhost/ionic-proyectos/movil-catalogo-quinchau/api-quinchau/',
			rootApiRestFull:'https://catalogo.to-do-easy.com/webmaster2/api-quinchau/',
			// rootApiRestFull:'https://quinchau.com/webmaster2/api-quinchau-test/',
			modalproducto:null,
			paginaActual:1,
			dataToken:{
				usuario:{},
				app:{},
				token: window.localStorage.getItem('userToken_v1_2')
			},
			front: JSON.parse(window.localStorage.getItem('front_v1_2')) != null ? JSON.parse(window.localStorage.getItem('front_v1_2')) : {
				usuario:{
					cotizacion_cliente_id: "",
					cotizacion_cliente_nombre: "",
					cotizacion_cliente_telefono_prefijo: "424",
					cotizacion_cliente_telefono_numero: ""
				},
				typeabbrev: "02",
				vendedor: "",
				listado: {
					busqueda: "",
					categoria: "",
					ordenar: "reciente",
					ordenar_new: "reciente",
					ordenar_modo: "desc"
				},
				cart: {
					cotizacion_id: "",
					productos: new Array(),
					total: "$0.00"
				}
			} 
		};

		if ( this.configuracion.front.listado.ordenar_new == undefined ) {
			this.configuracion.front.listado.ordenar_new = 'reciente';
		}
		if ( this.configuracion.front.listado.categoria == undefined ) {
			this.configuracion.front.listado.categoria = '';
		}
		if ( this.configuracion.front.listado.categoria_nombre == undefined ) {
			this.configuracion.front.listado.categoria_nombre = '';
		}
		if ( this.configuracion.front.listado.marca == undefined ) {
			this.configuracion.front.listado.marca = '';
		}
		if ( this.configuracion.front.listado.modelo == undefined ) {
			this.configuracion.front.listado.modelo = '';
		}
		if ( this.configuracion.front.listado.modelos == undefined ) {
			this.configuracion.front.listado.modelos = new Array();
		}
		if ( this.configuracion.front.listado.tags == undefined ) {
			this.configuracion.front.listado.tags = new Array();
		}

		if ( this.configuracion.front.listado.tag == undefined ) {
			this.configuracion.front.listado.tag = "";
		}
		if ( this.configuracion.front.listado.tag_descripcion == undefined ) {
			this.configuracion.front.listado.tag_descripcion = "";
		}
	}

	productosChange = new EventEmitter();

	drawerObject = {
		tipo: "modal",
		open: false
	}
	feedProductos = {
		cargando: true,
		productos: new Array(),
		paginaActual: 1,
	}
	public setDataFront(){
		window.localStorage.setItem('front_v1_2', JSON.stringify(this.configuracion.front) );
		this.productosChange.emit();
	}

	public getProductosChangeEmitter(){
		return this.productosChange;
	}
	
	public setDataToken(dataToken){
		if(!dataToken.token){
			window.localStorage.removeItem('userToken_v1_2');
		}else{
			window.localStorage.setItem('userToken_v1_2',dataToken.token);
		}
		
		this.configuracion.dataToken = dataToken;
	}
	
}
